import MotionController from "../lib/motion_controller"
import { gsap } from "../lib/motion"

// Counts a number up once when it scrolls into view. The server-rendered text is the final
// value, so no-JS and reduced-motion visitors see the real number.
//   data-controller="count-up" data-count-up-to-value="40" data-count-up-suffix-value="+"
export default class extends MotionController {
  static values = {
    to: Number,
    from: { type: Number, default: 0 },
    decimals: { type: Number, default: 0 },
    prefix: String,
    suffix: String,
    duration: { type: Number, default: 1.8 },
    start: { type: String, default: "top 85%" }
  }

  animate({ motion }) {
    if (!motion) return

    const original = this.element.textContent
    const format = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: this.decimalsValue,
      maximumFractionDigits: this.decimalsValue
    })
    const counter = { value: this.fromValue }
    const render = () => {
      this.element.textContent = `${this.prefixValue}${format.format(counter.value)}${this.suffixValue}`
    }

    render()
    gsap.to(counter, {
      value: this.toValue,
      duration: this.durationValue,
      ease: "expo.out",
      onUpdate: render,
      scrollTrigger: { trigger: this.element, start: this.startValue, once: true }
    })

    return () => { this.element.textContent = original }
  }
}
